const UTILS = require("../libs/utils.js");
const config = require("../config.js");
for (var vA766 = [{
    name: "KR Package",
    noCustoms: true,
    rarity: 0,
    icon: 0,
    claimTime: 2500,
    claim: function (p16786, p16787, p16788, p16789, p16790) {
      if (!p16789 || !p16789.account) {
        return false;
      }
      var vLN59 = 5;
      p16789.additionalReward += vLN59;
      p16789.send("am", [p16790 ? "KR Thief" : "KR Claimed", vLN59 + " KR", 0, 1]);
      p16789.send("ch", 0, null, "Claimed " + vLN59 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 1,
    icon: 0,
    claimTime: 2500,
    claim: function (p16791, p16792, p16793, p16794, p16795) {
      if (!p16794 || !p16794.account) {
        return false;
      }
      var vLN1019 = 10;
      p16794.additionalReward += vLN1019;
      p16794.send("am", [p16795 ? "KR Thief" : "KR Claimed", vLN1019 + " KR", 0, 1]);
      p16794.send("ch", 0, null, "Claimed " + vLN1019 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 2,
    icon: 0,
    claimTime: 2500,
    claim: function (p16796, p16797, p16798, p16799, p16800) {
      if (!p16799 || !p16799.account) {
        return false;
      }
      var vLN1511 = 15;
      p16799.additionalReward += vLN1511;
      p16799.send("am", [p16800 ? "KR Thief" : "KR Claimed", vLN1511 + " KR", 0, 1]);
      p16799.send("ch", 0, null, "Claimed " + vLN1511 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 3,
    icon: 0,
    claimTime: 2500,
    claim: function (p16801, p16802, p16803, p16804, p16805) {
      if (!p16804 || !p16804.account) {
        return false;
      }
      var vLN2012 = 20;
      p16804.additionalReward += vLN2012;
      p16804.send("am", [p16805 ? "KR Thief" : "KR Claimed", vLN2012 + " KR", 0, 1]);
      p16804.send("ch", 0, null, "Claimed " + vLN2012 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 4,
    icon: 0,
    claimTime: 3000,
    claim: function (p16806, p16807, p16808, p16809, p16810) {
      if (!p16809 || !p16809.account) {
        return false;
      }
      var vLN309 = 30;
      p16809.additionalReward += vLN309;
      p16809.send("am", [p16810 ? "KR Thief" : "KR Claimed", vLN309 + " KR", 0, 1]);
      p16809.send("ch", 0, null, "Claimed " + vLN309 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 5,
    icon: 0,
    claimTime: 3000,
    claim: function (p16811, p16812, p16813, p16814, p16815) {
      if (!p16814 || !p16814.account) {
        return false;
      }
      var vLN10013 = 100;
      p16814.additionalReward += vLN10013;
      p16814.send("am", [p16815 ? "KR Thief" : "KR Claimed", vLN10013 + " KR", 0, 1]);
      p16814.send("ch", 0, null, "Claimed " + vLN10013 + " KR", 2);
      return true;
    }
  }, {
    name: "KR Package",
    noCustoms: true,
    rarity: 6,
    icon: 0,
    animate: true,
    claimTime: 4500,
    claim: function (p16816, p16817, p16818, p16819, p16820) {
      if (!p16819 || !p16819.account) {
        return false;
      }
      var vLN250 = 250;
      p16819.additionalReward += vLN250;
      p16819.send("am", [p16820 ? "KR Thief" : "KR Claimed", vLN250 + " KR", 0, 1]);
      p16819.send("ch", 0, null, "Claimed " + vLN250 + " KR", 2);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 0,
    icon: 3,
    claimTime: 2500,
    claim: function (p16821, p16822, p16823, p16824, p16825) {
      if (!p16824 || !p16824.account) {
        return false;
      }
      var vLN005 = 0.05;
      p16824.send("am", [p16825 ? "Junk Thief" : "Junk Claimed", vLN005 + " Junk", 0, 1]);
      p16821.sendUserJunk("airdrop", p16824, vLN005);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 1,
    icon: 3,
    claimTime: 2500,
    claim: function (p16826, p16827, p16828, p16829, p16830) {
      if (!p16829 || !p16829.account) {
        return false;
      }
      var vLN011000 = 0.1;
      p16829.send("am", [p16830 ? "Junk Thief" : "Junk Claimed", vLN011000 + " Junk", 0, 1]);
      p16826.sendUserJunk("airdrop", p16829, vLN011000);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 2,
    icon: 3,
    claimTime: 2500,
    claim: function (p16831, p16832, p16833, p16834, p16835) {
      if (!p16834 || !p16834.account) {
        return false;
      }
      var vLN02472 = 0.2;
      p16834.send("am", [p16835 ? "Junk Thief" : "Junk Claimed", vLN02472 + " Junk", 0, 1]);
      p16831.sendUserJunk("airdrop", p16834, vLN02472);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 3,
    icon: 3,
    claimTime: 2500,
    claim: function (p16836, p16837, p16838, p16839, p16840) {
      if (!p16839 || !p16839.account) {
        return false;
      }
      var vLN03101 = 0.3;
      p16839.send("am", [p16840 ? "Junk Thief" : "Junk Claimed", vLN03101 + " Junk", 0, 1]);
      p16836.sendUserJunk("airdrop", p16839, vLN03101);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 4,
    icon: 3,
    claimTime: 3000,
    claim: function (p16841, p16842, p16843, p16844, p16845) {
      if (!p16844 || !p16844.account) {
        return false;
      }
      var vLN05101 = 0.5;
      p16844.send("am", [p16845 ? "Junk Thief" : "Junk Claimed", vLN05101 + " Junk", 0, 1]);
      p16841.sendUserJunk("airdrop", p16844, vLN05101);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 5,
    icon: 3,
    claimTime: 3000,
    claim: function (p16846, p16847, p16848, p16849, p16850) {
      if (!p16849 || !p16849.account) {
        return false;
      }
      var vLN1170 = 1;
      p16849.send("am", [p16850 ? "Junk Thief" : "Junk Claimed", vLN1170 + " Junk", 0, 1]);
      p16846.sendUserJunk("airdrop", p16849, vLN1170);
      return true;
    }
  }, {
    name: "Junk Package",
    noCustoms: true,
    rarity: 6,
    icon: 3,
    animate: true,
    claimTime: 4500,
    claim: function (p16851, p16852, p16853, p16854, p16855) {
      if (!p16854 || !p16854.account) {
        return false;
      }
      var vLN254 = 2.5;
      p16854.send("am", [p16855 ? "Junk Thief" : "Junk Claimed", vLN254 + " Junk", 0, 1]);
      p16851.sendUserJunk("airdrop", p16854, vLN254);
      return true;
    }
  }, {
    name: "Trapped Package",
    noCustoms: true,
    rarity: 1,
    icon: 1,
    imitate: true,
    color: "#e51b23",
    claimTime: 1000,
    claim: function (game, p16857, p16858, p16859) {
      p16859.send("so", "taunt_2", 1, 1, 0, 0, 0, 1, null, null);
      game.players.giveEffect(p16859, 6, game.effects[6].max);
      return false;
    }
  }, {
    name: "Trapped Package",
    noCustoms: true,
    rarity: 2,
    icon: 1,
    imitate: true,
    color: "#e51b23",
    claimTime: 1000,
    claim: function (game, p16861, p16862, p16863) {
      p16863.send("so", "taunt_3", 1, 1, 0, 0, 0, 1, null, null);
      game.players.giveEffect(p16863, 4, game.effects[4].max);
      game.players.giveEffect(p16863, 5, game.effects[5].max);
      return false;
    }
  }, {
    name: "Trapped Package",
    noCustoms: true,
    rarity: 3,
    icon: 1,
    imitate: true,
    color: "#e51b23",
    claimTime: 1000,
    claim: function (game, p16865, p16866, p16867) {
      p16867.send("so", "taunt_4", 1, 1, 0, 0, 0, 1, null, null);
      var v13513 = game.players.findBySid(p16866.owner);
      game.explosion(p16866.x, p16866.y + p16866.heightS / 2, p16866.z, 50, 300, v13513 || p16867, {
        stk: 1,
        pkg: 1
      });
      return false;
    }
  }, {
    name: "Skin Package",
    noCustoms: true,
    rarity: 4,
    icon: 2,
    claimTime: 3000,
    claim: function (p16868, p16869, p16870, p16871) {
      if (!p16871 || !p16871.account) {
        return false;
      }
      var v13514 = p16868.store.skins.filter(p16872 => p16872 && p16872.package);
      UTILS.yateShuffle(v13514);
      if (!v13514 || !v13514.length) {
        return false;
      }
      var v13515 = v13514[0].index;
      p16868.giveSkin(p16871, v13515, "package");
      return true;
    }
  }, {
    name: "Juggernaut Package",
    noCustoms: true,
    rarity: 5,
    icon: 5,
    streak: 5,
    claimTime: 3000,
    claim: function (game, p16874, p16875, p16876) {
      if (!p16876 || !p16876.account) {
        return false;
      }
      let vLN510 = 5;
      game.streaks[vLN510].activate(game, p16876, p16874);
      game.challenges.update(game, "stk", 1, {
        stk: vLN510
      }, p16876);
      return true;
    }
  }, {
    name: "War Machine Package",
    noCustoms: true,
    rarity: 4,
    icon: 6,
    streak: 6,
    claimTime: 3000,
    claim: function (game, p16878, p16879, p16880) {
      if (!p16880 || !p16880.account) {
        return false;
      }
      let vLN613 = 6;
      game.streaks[vLN613].activate(game, p16880, p16878);
      game.challenges.update(game, "stk", 1, {
        stk: vLN613
      }, p16880);
      return true;
    }
  }, {
    name: "Nuke Package",
    noCustoms: true,
    rarity: 6,
    icon: 7,
    animate: true,
    streak: 0,
    claimTime: 3000,
    claim: function (game, p16882, p16883, p16884) {
      if (!p16884 || !p16884.account) {
        return false;
      }
      let vLN02473 = 0;
      game.streaks[vLN02473].activate(game, p16884, p16882);
      game.challenges.update(game, "stk", 1, {
        stk: vLN02473
      }, p16884);
      return true;
    }
  }, {
    name: "Slimer Package",
    noCustoms: true,
    rarity: 3,
    icon: 8,
    streak: 4,
    claimTime: 3000,
    claim: function (game, p16886, p16887, p16888) {
      if (!p16888 || !p16888.account) {
        return false;
      }
      let vLN417 = 4;
      game.streaks[vLN417].activate(game, p16888, p16886);
      game.challenges.update(game, "stk", 1, {
        stk: vLN417
      }, p16888);
      return true;
    }
  }], vLN02474 = 0; vLN02474 < vA766.length; vLN02474++) {
  vA766[vLN02474].index = vLN02474;
}
module.exports = vA766;